// update state
const setActionWbdvUrl = (payload) => {
    return {
        type: "ACTIONURL",
        payload
    }
}

export default setActionWbdvUrl;


// WEBPACK FOOTER //
// ./src/actions/setActionWbdvUrl.js